import React from 'react';
import DatePicker from 'components/DatePicker';

import './dateFilterCard.style.css';
import { Radio, Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import messages from '../UI/messages';

const dateFilterCard = ({ onDateSelectChange, selectedDate, onDayOrDateComparisonChange, dayComparisonValue }) => {
    const onChangeDayOrDateComparison = (e) => {
        onDayOrDateComparisonChange(e.target.value);
    };
    return (
        <div style={{ position: 'sticky', top: 80, zIndex: 998 }}>
            <div className="DateFilterCardWrapper">
                <div className="DateFilterCard">
                    <Space>
                        <div>
                            <DatePicker
                                onChange={onDateSelectChange}
                                defaultValue={selectedDate}
                                format="DD/MM/YYYY"
                                className="DateFilterCardDatepicker"
                            />
                        </div>
                        {dayComparisonValue !== undefined && dayComparisonValue !== null && (
                            <div className="periodPicker">
                                <Space>
                                    <FormattedMessage {...messages.lastYearComparisonLabel} />
                                    <Radio.Group onChange={onChangeDayOrDateComparison} value={dayComparisonValue} buttonStyle="solid">
                                        <Radio.Button value>
                                            <FormattedMessage {...messages.labelLastYearComparisonByDay} />
                                        </Radio.Button>
                                        <Radio.Button value={false}>
                                            <FormattedMessage {...messages.labelLastYearComparisonByDate} />
                                        </Radio.Button>
                                    </Radio.Group>
                                </Space>
                            </div>
                        )}
                    </Space>
                </div>
            </div>
        </div>
    );
}

export default dateFilterCard;
